// @ts-nocheck
import { useState, useRef, useReducer, useEffect } from 'react';
import { Dialog } from "primereact/dialog";
import { Card } from 'primereact/card';
import { Slider } from 'primereact/slider';
import { Calendar } from 'primereact/calendar';
import { ColorPicker } from 'primereact/colorpicker';
import "../../assets/functionalComponents/_dialog.scss"
import "../../assets/functionalComponents/_dataItem.scss"
import "../../assets/functionalComponents/ScrollPanelDemo.css"

export const TimeSetOption = (props) => {

    const [playSpeed, setPlaySpeed] = useState(1);

    useEffect(() => {
        if (window.widgetTimelinePlayer === null)
            return;
        window.widgetTimelinePlayer.updateParameter({ playSpeed: playSpeed });
    }, [playSpeed])
    
    return (
        <Dialog header="演示時間軸設定" visible={props.TimeSet} modal={false} position={'bottom-right'} keepInViewport={false} onHide={() => props.onHide('TimeSet')}>
            <Card title="演示時間區間設定" subTitle="設定時間軸循環播放區間">
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">開始時間：</label>
                    <div className="col-12 md:col-8">
                        <Calendar id="startTimeCalendar" value={props.startTime} onChange={(e) => props.setStartTime(e.value)} showTime showSeconds showButtonBar style={{ width: "100%" }} />
                    </div>
                </div>
                <div className="field grid">
                    <label class="col-12 mb-4 md:col-4 md:mb-0">結束時間：</label>
                    <div className="col-12 md:col-8">
                        <Calendar id="endTimeCalendar" value={props.endTime} onChange={(e) => props.setEndTime(e.value)} minDate={props.startTime} showTime showSeconds showButtonBar style={{ width: "100%" }} />
                    </div>
                </div>
            </Card>
            <br></br>
            <Card title="時間軸運行速度倍率" subTitle="設定時間軸播放速度倍率">
                <h5>{playSpeed} 倍 / 1秒</h5>
                <Slider value={playSpeed} onChange={(e) => setPlaySpeed(e.value)} min={1} max={10000} />
            </Card>
        </Dialog>
    )
}